import { FormFieldsGeneratorService } from './../../customer-form/form-helpers/form-fields-generator.service';
import { FormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { ProcessTypeEnum } from '../../models/cartDetails/process-type.enum';
import SlotFirstPageModel from '../../models/slot-first-page.model';
import ProcessInputModel from '../../models/process-input.model';
import SlotStateService from '../../cart-process/slot-state.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import DrawingNewNumberService from '../draw-number/drawing-new-number.service';
import { FormFieldsMasks } from '../../customer-form/field-mask/form-fields-masks';
import { BundleTypeEnum } from '../../models/cartDetails/bundle-type.enum';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Component({
  selector: 'slot-process-input',
  templateUrl: './slot-process-input.component.html'
})
export default class SlotProcessInputComponent implements OnInit {
  @Input() private slotFactory: any;
  @Input() set slotData(slot: SlotFirstPageModel) {
    this.slot = slot;
    this.tempState = slot._computedFields.tempState;

    this.isEditState = this.slotStateService.isInProgress(this.tempState);
    this.viewData = this.getViewDataByProcess(this.tempState.processName);
  }

  public isEditState: boolean;
  public tempState: any;
  public viewData: ProcessInputModel;
  public validationMasks: FormFieldsMasks;
  public slot: SlotFirstPageModel;
  public slotProcessForm: FormGroup;

  constructor(
    private slotStateService: SlotStateService,
    private drawingNewNumberService: DrawingNewNumberService,
    private notificationProvider: NotificationProviderService,
    private commonInfo: CommonInfoService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
    this.validationMasks = new FormFieldsMasks();
  }

  ngOnInit(): void {
    const lastValue = this.notificationProvider.getValue(NotificationProviderTypeEnum.PAGE_VALIDATION_CART);

    if (lastValue && lastValue._source === 'firstPage') {
      const slotTempState = this.slotStateService.getTempState(this.slot.bundleNumber);
      const slotOriginalState = this.slotStateService.getOriginalState(this.slot.bundleNumber);

      slotTempState.UPSELL_EDIT_STATE = slotOriginalState.UPSELL_EDIT_STATE;
      slotTempState.RETENTION_EDIT_STATE = slotOriginalState.RETENTION_EDIT_STATE;
      slotTempState.PREPAID_2_POSTPAID_EDIT_STATE = slotOriginalState.PREPAID_2_POSTPAID_EDIT_STATE;

      this.isEditState = this.slotStateService.isInProgress(this.tempState);

      if (this.isEditState) {
        this.formsGenerator.setFirstStepActiveForm();
        this.slotProcessForm = this.formsGenerator.activeForm;
      }
    }
  }

  public selectNewNumber(event: Event): void {
    event.preventDefault();

    this.drawingNewNumberService.selectNewNumber(this.slot);
  }

  private getViewDataByProcess(processName: ProcessTypeEnum): ProcessInputModel {

    const result = new ProcessInputModel(this.tempState);

    switch (processName) {
      case ProcessTypeEnum.ACQUISITION:
        result.showReloadIcon = !this.slot.isDataOffer;
        result.msisdnLabel = `Nowy numer w ${this.commonInfo.isVirginBrand ? 'Virgin Mobile' : 'Play'}`;
        result.inputLabel = '';
        break;

      case ProcessTypeEnum.MNP:
        result.inputId = 'tel-play-current-number-' + this.slot.ordinal;
        result.showReloadIcon = false;
        result.msisdnLabel = 'Mój numer z innej sieci';
        result.inputLabel = 'Podaj numer, który chcesz przenieść';
        result.tempStateMsisdnField = 'newMnpNumberValue';

        result.submitNumber = (event: Event) => {
          event.preventDefault();

          this.formsGenerator.checkActiveFormValidation();
          this.slotFactory.changeProcessToMNP();
        };
        break;

      case ProcessTypeEnum.UPSELL:
        result.inputId = 'tel-play-current-number-' + this.slot.ordinal;
        result.showReloadIcon = this.slot.isVoiceOffer;
        result.msisdnLabel = `Nowy numer w ${this.commonInfo.isVirginBrand ? 'Virgin Mobile' : 'Play'}`;
        result.tempStateMsisdnField = 'upsellLoginNumberValue';

        if (this.slot.isVoiceOffer) {
          result.inputLabel = 'Zaloguj się swoim numerem w Play<br>i dokup nowy numer';
        } else if (this.slot.isDataOffer) {
          result.inputLabel = 'Zaloguj się swoim numerem w Play<br>i dokup nową usługę';
        }

        result.submitNumber = (event: Event) => {
          event.preventDefault();

          this.slotFactory.changeProcessToUpsell(this);
        };

        break;

      case ProcessTypeEnum.RETENTION:
        result.inputId = 'tel-play-retention-number-' + this.slot.ordinal;
        result.showReloadIcon = false;
        result.msisdnLabel = 'Przedłużam umowę';
        result.inputLabel = 'Podaj numer, dla którego chcesz przedłużyć umowę';
        result.tempStateMsisdnField = 'newRetentionNumberValue';

        result.submitNumber = (event: Event) => {
          event.preventDefault();

          this.slotFactory.changeProcessToRetention(this);
        };
        break;

      case ProcessTypeEnum.PREPAID_2_POSTPAID: // migracja
        result.inputId = 'tel-play-migration-number-' + this.slot.ordinal;
        result.showReloadIcon = false;
        result.msisdnLabel = 'Przechodzę z karty na abonament';
        result.inputLabel = 'Podaj numer, który zmieniasz na abonament';
        result.tempStateMsisdnField = 'newPrepaid2PostpaidNumberValue';

        result.submitNumber = (event: Event) => {
          event.preventDefault();

          this.slotFactory.changeProcessToPrepaid2Postpaid(this);
        };
        break;
    }

    if (this.slot.bundleType === BundleTypeEnum.ADDITIONAL_OFFER) {
      result.showReloadIcon = false;
    }

    return result;
  }
}

